import { AlarmClock } from "lucide-react";
import { useTimer } from "../../hooks/timer";
import "../../style/Timer.css"

const Timer = ({
    timeTotal,
    onFinish
}) => {
  

  const [
    timeLeftTimer,
    minuteTimer,
    secondTimer,
    isRunning,
    hasEndedTimer,
    startTimer,
    pauseTimer,
    stopTimer,
    resetTimer,
  ] = useTimer(timeTotal, onFinish, true);






    let shakingEffectTimer = 
    timeLeftTimer <= 10 ? "shake-high" :   //high
    timeLeftTimer <= 30 ? "shake-medium" : //medium
    timeLeftTimer <= 60 ? "shake-light" :  //light
    ""; //nothing
  return (
    <div className="timer_div">
        <AlarmClock
        className={`timer_icon ${shakingEffectTimer}`}
        size={80}
        color="#ffffff"
        />
        <h2 className="timer_text">{`${String(minuteTimer).padStart(
        2,
        "0"
        )}:${String(secondTimer).padStart(2, "0")}`}</h2>
    </div>
  );
};

export default Timer;